module.exports = "/assets/data/9af78eff4e8350f4af9d518287d2ea95-B24.data.json";